export default __webpack_public_path__ + "static/media/other-cause.0a06ea21.png";